<!--
 * @Descripttion:
 * @Author: sch
 * @LastEditTime: 2022-04-22 11:51:59
-->
<template>
  <div class="container">
    <div class="no_ask">
      <div class="top_mesage" v-if="$route.query.showbuy != 0">
        <img class="img_product" v-lazy="productObj.img_path" />
        <div class="middle_txt">
          <p class="p_top">{{ productObj.name }}</p>
          <!-- <p class="p_bottom">查看产品</p> -->
        </div>
        <span class="rt_btn" @click="goBuy">去购买</span>
      </div>
      <div class="no_concent" v-if="dataList.length == 0">
        <div class="ask_no">
          <div class="wen">问</div>
          <div class="txt">暂时没有问题哦</div>
        </div>
        <div class="md_concent">
          <img src="../../../static/images/buyersShow/wendajia.png" />
          <div class="words">暂时还没有问题,去提问吧~</div>
        </div>
      </div>
    </div>
    <!-- <Scroller :is-refresh-data.sync="refresh"
            :is-loading-data.sync="loading"
            :is-finished-data.sync="finished"
            :no-data-text-data.sync="noDataText"
            @on-refresh="onRefresh"
            @on-infinite="onInfinite"
            ref="my_scroller"
  > -->
    <div class="ask_list" v-if="dataList.length > 0">
      <div class="list_block" v-for="(items, index) of dataList" :key="index">
        <div class="ask_b">
          <div class="lt_txt">问</div>
          <div class="rt_txts">{{ items.question }}</div>
        </div>
        <div class="answer_b" v-if="items.answernum == 0">
          <div class="answer">答</div>
          <div class="txt" @click="seeAllQusetion(items)">暂无回答,答友们正火速赶来。</div>
        </div>
        <div class="answer_show" v-else>
          <div class="answers">答</div>
          <div class="txts">
            <span class="name">{{ items.smallname }}:</span>
            {{ items.answer }}
          </div>
        </div>
        <div class="answer_num" v-if="items.answernum != 0">
          <div class="txt" @click="seeAllQusetion(items)">全部{{ items.answernum }}个回答></div>
        </div>
      </div>
    </div>
    <!-- </Scroller> -->

    <div class="bottom_block">
      <input type="text" class="inputs" placeholder="向已买过的人提问" v-model="inputVal" />
      <span class="btn" @click="submitQuestion">提问</span>
    </div>
  </div>
</template>
<script>
import Scroller from '../common/Scroller'

export default {
  components: {
    Scroller
  },
  data() {
    return {
      inputVal: '',
      dataList: [],
      productObj: {
        img_path: '',
        name: '',
        problemsnum: ''
      },
      refresh: false,
      loading: false,
      finished: false,
      nowPage: 0,
      noDataText: '—— 客官，木有啦~ ——'
    }
  },

  created() {
    this.getList()
    this.inputVal = ''
  },
  methods: {
    onRefresh() {
      this.refresh = true
      this.nowPage = 1
      this.datas = []
      var that = this
      that.getList()
    },
    onInfinite() {
      this.loading = true
      this.finished = false
      var that = this
      // setTimeout(function () {
      that.nowPage++
      that.getList()
      // }, 400)
    },
    getList() {
      var url =
        this.$ajax.getQandalist_URL +
        '?itemid=' +
        this.$route.query.itemid +
        '&pageno=' +
        this.nowPage +
        '&pagesize=' +
        this.pagesize
      this.$customRequestAjax(url)
        .then((res) => {
          if (res.data.code === 200) {
            this.productObj.img_path = res.data.img_path
            this.productObj.name = res.data.name
            this.productObj.problemsnum = res.data.problemsnum
            if (this.nowPage === 1) {
              this.dataList = res.data.list
              this.refresh = false
            } else {
              this.dataList = this.dataList.concat(res.data.list)
            }
            this.loading = false
            if (res.data.list.length < this.pagesize) {
              this.finished = true
            } else {
              this.finished = false
            }
          }
        })
        .catch((err) => {})
    },
    //提问提交
    submitQuestion() {
      if (this.inputVal == '') {
        this.$toast('内容不能为空')
        return
      }
      this.$ckeckgraphic({
        content: this.inputVal,
        callback: () => {
          if (this.inputVal.replace(/ /g, '') != '') {
            let urls = this.$ajax.submitQuestions_URL
            let data = {
              question: this.inputVal,
              itemid: this.$route.query.itemid
            }
            this.$customRequestAjax
              .post(urls, data)
              .then((res) => {
                console.log('提问提交返回', res.data.list)
                if (res.data.code == 200) {
                  this.$toast('提问成功')
                  this.inputVal = ''
                }
              })
              .catch((err) => {})
          } else {
            this.$toast('内容不能为空')
          }
        }
      })
    },
    seeAllQusetion(item) {
      var query = this.$route.query
      query.questionid = item.questionid
      query.questionName = item.question
      this.$router.push({
        path: '/problemDetails',
        query: query
      })
    },
    goBuy() {
      this.$router.push({
        path: '/productdetail',
        query: {
          ...this.$route.query
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  box-sizing: border-box;
  overflow: auto;
  background: #f7f4f8;
  font-size: 0.14rem;
  position: relative;
  .no_ask {
    padding: 0 0.11rem;
    .top_mesage {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: flex-start;
      padding: 0.15rem 0.11rem 0.04rem;
      img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.08rem;
      }
      .middle_txt {
        width: 70%;
        .p_top {
          color: #333333;
          font-size: 0.14rem;
          padding-bottom: 0.05rem;
          height: 0.4rem;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }
        .p_bottom {
          color: #afb0af;
          font-size: 0.12rem;
        }
      }
      .rt_btn {
        width: 0.7rem;
        height: 0.28rem;
        line-height: 0.28rem;
        text-align: center;
        border: 0.01rem solid red;
        color: red;
        border-radius: 0.2rem;
        margin-top: 0.06rem;
      }
    }
    .no_concent {
      margin-top: 0.11rem;
      background: #fff;
      height: calc(100vh - 1.26rem);
      border-radius: 0.08rem 0.08rem 0 0;
      .ask_no {
        width: 93%;
        margin: 0 auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        padding: 0.15rem 0.05rem;
        border-bottom: 0.01rem solid #c8c9cc36;
        .wen {
          background: red;
          color: #fff;
          border-radius: 0.04rem;
          margin: 0 0.05rem;
          padding: 0 0.03rem;
        }
        .txt {
          font-weight: 600;
          color: #070707;
          font-size: 0.16rem;
        }
      }
      .md_concent {
        text-align: center;
        margin-top: 1.35rem;
        img {
          width: 0.8rem;
          height: 0.8rem;
          display: block;
          margin: 0 auto;
        }
        .words {
          margin-top: 0.15rem;
          color: #6e6e6e;
        }
      }
    }
  }
  .ask_list {
    .list_block {
      background: #fffeff;
      border-radius: 0.08rem;
      margin: 0.1rem 0.11rem;
      .ask_b {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        padding: 0.15rem 0.05rem;
        .lt_txt {
          background: red;
          color: #fff;
          border-radius: 0.04rem;
          margin: 0.01rem 0.05rem;
          padding: 0 0.03rem;
          height: 0.2rem;
        }
        .rt_txts {
          font-weight: 600;
          color: #070707;
          font-size: 0.16rem;
        }
      }
      .answer_b {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        padding: 0 0.05rem 0.15rem;
        .answer {
          background: #72d59c;
          color: #fff;
          border-radius: 0.04rem;
          margin: 0 0.05rem;
          padding: 0 0.03rem;
          height: 0.2rem;
        }
        .txt {
          font-size: 0.14rem;
          color: #222222;
        }
      }
      .answer_show {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        padding: 0 0.05rem 0.15rem;
        .answers {
          height: 0.2rem;
          background: #72d59c;
          color: #fff;
          border-radius: 0.04rem;
          margin: 0 0.05rem;
          padding: 0 0.03rem;
        }
        .txts {
          font-size: 0.14rem;
          color: #222222;
          .name {
            color: #999999;
            padding-right: 0.05rem;
          }
        }
      }
      .answer_num {
        padding: 0 0.05rem 0.15rem;
        text-align: left;
        .txt {
          font-size: 0.12rem;
          color: red;
          padding-left: 0.3rem;
        }
      }
    }
  }
  &:last-child {
    margin-bottom: 0.56rem;
  }
  .bottom_block {
    width: 100%;
    padding: 0.1rem 0.11rem 0.15rem 0.11rem;
    background: #fff;
    position: fixed;
    bottom: 0;
    border-top: 0.01rem solid #00000040;
    .inputs {
      background: #f7f4f8;
      outline: none;
      border: 0.01rem solid #f7f4f8;
      height: 0.3rem;
      width: 77%;
      border-radius: 0.15rem;
      padding-left: 0.1rem;
      color: #333;
    }
    .inputs:focus {
      border: none;
    }
    .btn {
      background: #fc0324;
      color: #fff;
      width: 0.65rem;
      border-radius: 0.15rem;
      height: 0.3rem;
      line-height: 0.3rem;
      display: inline-block;
      text-align: center;
      float: right;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/buyersShow/askEveryone.vue